<template>
  <div class="steps-item-component">
    <span href="#" class="steps-marker"></span>
    <div
      class="steps-content"
      :class="{ 'is-fullwidth': fullWidth }"
    >
      <!-- Usando flexbox para melhor controle no mobile -->
      <div class="columns is-mobile is-vcentered is-justify-content-space-between">
        <!-- Coluna do Nome (ocupa espaço disponível) -->
        <div
            class="column is-narrow-tablet is-narrow-desktop is-narrow-widescreen is-narrow-fullhd is-flex-grow-1 is-flex-shrink-1"
        >
          <!-- Tamanhos de texto responsivos -->
          <span class="is-size-6-mobile is-size-5-tablet has-text-weight-bold has-text-grey-dark" v-if="name">
            {{ name }}
            <!-- Removido span de pontos -->
          </span>
        </div>
        <!-- Coluna do Preço (tamanho automático) -->
        <div class="column is-narrow" v-if="price">
          <span class="is-pulled-right">
            <!-- Tamanhos de texto responsivos -->
            <span class="is-size-7-mobile is-size-6-tablet has-text-weight-light has-text-grey-secondary">R$ </span>
            <span class="is-size-7-mobile is-size-6-tablet has-text-weight-light has-text-grey-secondary">{{ formatPrice(price) }}</span>
            <span class="is-size-7-mobile is-size-6-tablet has-text-weight-light has-text-grey-secondary" v-if="unit">/{{ unit }}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {

  name: 'item',

  props: {
    name: {
      required: false,
      type: String
    },
    price: {
      required: false,
      type: String
    },
    unit: {
      required: false,
      type: String
    },
    fullWidth: {
      required: true,
      type: Boolean
    }
  },

  methods: {
    formatPrice(value) {
      return (parseFloat(value).toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' }))
          .replace('R$', '').trim();
    }
  }

}

</script>

<style lang="scss" scoped>
.steps-item-component {
  .is-no-wrap {
    white-space: nowrap;
  }

  .steps-content {
    /* Largura padrão (para sidebar desktop) */
    width: 30%; 
    padding-right: calc(0.25rem + 2em);

    /* Sobrescreve a largura para 100% no modo inline/fullwidth */
    &.is-fullwidth {
      width: 100% !important; /* Garante a sobrescrita */
      padding-right: 0; /* Remove padding desnecessário no modo fullwidth */
    }
  }

  /* Ajustes adicionais para mobile se necessário */
  @media screen and (max-width: 768px) {
    .steps-content {
      /* Garante que o padding não seja excessivo no mobile */
      padding-right: 0.5rem; 
      &.is-fullwidth {
         padding-right: 0;
      }
    }
    .column {
      /* Reduzir padding das colunas no mobile para economizar espaço */
      padding-top: 0.25rem;
      padding-bottom: 0.25rem;
    }
  }
  .steps-content {

    .column span {
      word-break: break-word;
      overflow-wrap: break-word;
      white-space: normal;
    }
  }
}
</style>